import { useLocation } from 'react-router';
import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { useUpdatingRef } from '@flame-frontend-utils/commons';
import { ViewPostBySlugForRankingDocument } from './ViewPostBySlugForRanking.document';

export function useReportPostViewForRanking() {
  const location = useLocation();
  const latestLocationRef = useUpdatingRef(location);
  const [reportPostViewForRanking] = useMutation(ViewPostBySlugForRankingDocument);

  return useCallback(
    (slug: string) => {
      void reportPostViewForRanking({
        variables: { slug, referrerUrl: latestLocationRef.current.pathname },
        context: { disableErrorPopup: true },
      });
    },
    [reportPostViewForRanking, latestLocationRef],
  );
}
